import { render, staticRenderFns } from "./closeInquiry.vue?vue&type=template&id=3bc8f930&scoped=true"
import script from "./closeInquiry.vue?vue&type=script&lang=js"
export * from "./closeInquiry.vue?vue&type=script&lang=js"
import style0 from "./closeInquiry.vue?vue&type=style&index=0&id=3bc8f930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc8f930",
  null
  
)

export default component.exports